import { useEffect, useState } from "react";

interface WatchlistCopyModalProps {
  open: boolean;
  sourceWatchlistName: string;
  busy?: boolean;
  onClose: () => void;
  onSubmit: (name: string) => Promise<void> | void;
}

export function WatchlistCopyModal({
  open,
  sourceWatchlistName,
  busy = false,
  onClose,
  onSubmit,
}: WatchlistCopyModalProps) {
  const [name, setName] = useState("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!open) {
      return;
    }
    const nextName = sourceWatchlistName ? `${sourceWatchlistName}_copy` : "watchlist_copy";
    setName(nextName);
    setError(null);
  }, [open, sourceWatchlistName]);

  if (!open) {
    return null;
  }

  async function handleSubmit() {
    const trimmed = name.trim();
    if (!trimmed) {
      setError("请输入新 watchlist 名称");
      return;
    }
    setError(null);
    await onSubmit(trimmed);
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/65 px-3" onClick={onClose}>
      <div
        className="w-[min(92vw,460px)] rounded-lg border border-[var(--border-strong)] bg-[#0f131b] shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="border-b border-[var(--border)] px-4 py-3">
          <div className="text-sm font-semibold text-slate-100">复制 Watchlist</div>
          <div className="mt-1 text-xs text-[var(--muted)]">源列表：{sourceWatchlistName || "--"}</div>
        </div>
        <div className="px-4 py-3">
          <label className="block text-xs text-slate-200">新列表名称</label>
          <input
            value={name}
            onChange={(event) => setName(event.target.value)}
            className="mt-1 h-9 w-full rounded border border-[var(--border)] bg-[#0b1017] px-2 text-sm text-slate-100"
            placeholder="请输入新的 watchlist 名称"
            autoFocus
            disabled={busy}
          />
          {error ? <div className="mt-2 text-xs text-rose-200">{error}</div> : null}
        </div>
        <div className="flex justify-end gap-2 border-t border-[var(--border)] px-4 py-3">
          <button
            className="h-8 rounded border border-[var(--border)] bg-[#111823] px-3 text-xs text-slate-200 hover:bg-white/5 disabled:opacity-50"
            onClick={onClose}
            disabled={busy}
          >
            取消
          </button>
          <button
            className="h-8 rounded border border-sky-400/40 bg-sky-500/20 px-3 text-xs text-sky-200 hover:bg-sky-500/30 disabled:opacity-50"
            onClick={() => void handleSubmit()}
            disabled={busy}
          >
            复制并切换
          </button>
        </div>
      </div>
    </div>
  );
}
